import { render } from "./ourVision.vue?vue&type=template&id=7c709268"
import script from "./ourVision.vue?vue&type=script&lang=js"
export * from "./ourVision.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__